// extracted by mini-css-extract-plugin
export default {"balance__caption":"styles_balance__caption__W9cMB"};